import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  SELECTABLE_UI_LANGUAGE_CODES,
  normalizeUiLanguageCode,
} from '../constants/uiLanguages';

const UiLanguageRouteWrapper = ({ children }) => {
  const { lang } = useParams();
  const location = useLocation();
  const { i18n } = useTranslation();
  const normalizedLanguage = normalizeUiLanguageCode(lang);

  useEffect(() => {
    if (!lang || !SELECTABLE_UI_LANGUAGE_CODES.includes(normalizedLanguage)) {
      return;
    }

    const currentLanguage = normalizeUiLanguageCode(i18n.resolvedLanguage || i18n.language);
    if (currentLanguage !== normalizedLanguage) {
      void i18n.changeLanguage(normalizedLanguage);
    }
  }, [i18n, lang, normalizedLanguage]);

  if (lang && !SELECTABLE_UI_LANGUAGE_CODES.includes(normalizedLanguage)) {
    const strippedPath = location.pathname.replace(/^\/[^/]+/, '') || '/';
    return (
      <Navigate
        to={{
          pathname: `/en${strippedPath === '/' ? '' : strippedPath}`,
          search: location.search,
          hash: location.hash,
        }}
        replace
      />
    );
  }

  return children;
};

export default UiLanguageRouteWrapper;
